import * as moment from 'moment';
import { Constants } from '../../core/constants';
import { Toro } from '../common/enumerations';

export class DailyWeatherModel
{
    public Weather: DailyWeatherIdAndDescription;
    public AirTemperatureAvg: number;
    public AirTemperatureMax: number;
    public AirTemperatureMin: number;
    public CloudCoverAvg: number;
    public DevPointAvg: number;
    public Eto: number;
    public PrecipitationProbability: number;
    public PrecipitationTotal: number;
    public RelativeHumidityAvg: number;
    public Sunrise: Date;
    public Sunset: Date;
    public Wind: DailyWeatherWindModel;

    public WeatherIcon: string;
    public WeatherDate: Date;

    constructor(json: object = null, weatherDateString: string)
    {
        if (json)
        {
            Object.assign(this, json);

            this.setWeatherIcon();

            this.WeatherDate = moment(weatherDateString).toDate();
        }
    }

    private setWeatherIcon()
    {
        const condition = this.setWeatherCondition();

        let standardConditionName = 'regular';

        for (const prop in Constants.WeatherStandardConditionNames)
        {
            if (Constants.WeatherStandardConditionNames.hasOwnProperty(prop))
            {
                const possibleName = Constants.WeatherStandardConditionNames[prop];
                possibleName.forEach(function (name)
                {
                    if (condition.toLowerCase().indexOf(name) > -1)
                    {
                        return standardConditionName = prop;
                    }
                }, this);
            }
        }

        const cloudCoverIndex = Math.floor(Math.max(0, this.CloudCoverAvg - 1) / 20);

        this.WeatherIcon = 'climacon-icon-' + Constants.WeatherConditionAndCloudCoverToIconMap[standardConditionName][cloudCoverIndex];
    }

    private setWeatherCondition()
    {
        if (this.Weather.Description.includes('Drizzle') || (this.Weather.Description.includes('Rain') && !this.Weather.Description.includes('Freezing')))
        {
            return Toro.WeatherForecastConditions.Drizzle;
        }
        else if ((this.Weather.Description.includes('Snow') && !this.Weather.Description.includes('Showers')) || this.Weather.Description.includes('Ice'))
        {
            return Toro.WeatherForecastConditions.Snow;
        }
        else if (this.Weather.Description.includes('Sleet'))
        {
            return Toro.WeatherForecastConditions.Sleet;
        }
        else if (this.Weather.Description.includes('Rain') && this.Weather.Description.includes('Freezing'))
        {
            return Toro.WeatherForecastConditions.FreezingRain;
        }
        else if (this.Weather.Description.includes('Showers'))
        {
            return Toro.WeatherForecastConditions.Showers;
        }
        else if (this.Weather.Description.includes('Rain'))
        {
            return Toro.WeatherForecastConditions.Rainfall;
        }
        else if (this.Weather.Description.includes('Thunder'))
        {
            return Toro.WeatherForecastConditions.Thunderstorm;
        }
        else if (this.Weather.Description.includes('Windy') || this.Weather.Description.includes('Overcast')
            || (this.Weather.Description.includes('Partly') && this.Weather.Description.includes('Cloudy'))
            || (this.Weather.Description.includes('Scattered') && this.Weather.Description.includes('Clouds'))
            || (this.Weather.Description.includes('Few') && this.Weather.Description.includes('Clouds'))
            || this.Weather.Description.includes('Breezy'))
        {
            return Toro.WeatherForecastConditions.PartlyCloudy;
        }
        else if (this.Weather.Description.includes('Broken') || this.Weather.Description.includes('Overcast')
            || this.Weather.Description.includes('Clouds') || this.Weather.Description.includes('Cloudy'))
        {
            return Toro.WeatherForecastConditions.Cloudy;
        }
        else if (this.Weather.Description.includes('Sunny'))
        {
            return Toro.WeatherForecastConditions.PartlySunny;
        }
        else if (this.Weather.Description.includes('Clear') || this.Weather.Description.includes('Fair'))
        {
            return Toro.WeatherForecastConditions.Sunny;
        }
        else
        {
            return Toro.WeatherForecastConditions.PartlyCloudy;
        }
    }
}

export class DailyWeatherWindModel
{
    public GustMax: number;
    public SpeedAvg: number;
    public SpeedMax: number;
    public SpeedMin: number;
}

export class DailyWeatherIdAndDescription
{
    public Id: number;
    public Description: string;
}
